export default "__VITE_ASSET__B5E9TyfV__"